module.exports = __webpack_public_path__ + "img/hyundai-Used.f4e3b0a6.png";